import { iappApiV1 } from '~/shared/services/api';
import { OperationCampaigns } from '~/shared/types/Campaign';

export async function sendOperationDocumentByEmail(
  operationType: OperationCampaigns
) {
  const response = await iappApiV1.post(`/documents/send-email`, {
    operationType
  });

  return response.data;
}
